const question = {
  QUESTION_ADD_NEW_ACTION: 'Create new question',
  QUESTION_POPCONFIRM_DELETE_TITLE: 'Are you sure you want to delete this question?',
  QUESTION_MESSAGE_HELP_TEXT: 'Type in # to drop some tags.',
}

export default question
